<template>
	<div>
		<v-dialog v-model="display" max-width="600">
			<v-card class="manual crew">
				<v-card-title>
					<h4>{{ $t('Banner_AI.DialogTitle') }}</h4>
					<v-btn icon dark @click="HANDLE_DIALOG_CLOSE">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form @submit.prevent="submitForm">
						<v-card>
							<v-row class="required">
								<v-col>{{ $t('ServicePages.InhabitantAdvantage.manualDialog.requiredNotice') }}</v-col>
							</v-row>
							<v-row>
								<v-col>
									<label class="required">{{ form.username.label }}</label>
									<v-text-field solo v-model="form.username.value"></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<label class="required">{{ form.apartment.label }}</label>
									<v-text-field solo v-model="form.apartment.value"></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<label>{{ form.phone.label }}</label>
									<v-text-field solo v-model="form.phone.value"></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<label class="required">{{ form.email.label }}</label>
									<v-text-field solo v-model="form.email.value"></v-text-field>
								</v-col>
							</v-row>
							<v-row class="btn_wrap">
								<v-col class="check_wrap">
									<v-checkbox v-model="check" :label="$t('ServicePages.InhabitantAdvantage.manualDialog.agreePrivacy')" color="white" hide-details></v-checkbox>
									<v-btn :href="usePrivacy" target="_blank">{{ $t('ServicePages.InhabitantAdvantage.manualDialog.viewTerms') }}</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn class="btn" @click.stop="submitForm">
						{{ $t('Banner_AI.button') }}<v-icon>mdi-plus</v-icon>
					</v-btn>
					<v-dialog v-model="ch_in_dialog" max-width="500">
						<v-card class="complete">
							<v-card-title>{{ $t('ServicePages.InhabitantAdvantage.completeDialog.title') }}</v-card-title>
							<v-card-text>{{ $t('ServicePages.InhabitantAdvantage.completeDialog.text') }}</v-card-text>
							<v-card-actions>
								<v-btn text @click="ch_in_dialog = false">{{ $t('ServicePages.InhabitantAdvantage.completeDialog.confirmButton') }}</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	data() {
		return {
			form: {
				username: { label: this.$t('QuestionPage.form.admin.name'), value: '' },
				apartment: { label: this.$t('QuestionPage.form.admin.company'), value: '' },
				phone: { label: this.$t('QuestionPage.form.admin.phone'), value: '' },
				email: { label: this.$t('QuestionPage.form.admin.email'), value: '' },
			},
			check: false,
			ch_in_dialog: false,
			usePrivacy: 'https://resource.eumservice.com/official/privacy.html'
		};
	},
	computed: {
		display: {
			get() {
				return this.$store.state.common.dialog.ai;
			},
			set(value) {
				this.$store.commit('common/setAiDialog', value);
			},
		},
	},
	methods: {
		...mapActions(['HANDLE_SEND_SLACK']),

		HANDLE_DIALOG_CLOSE()
		{
			this.$store.commit('common/setDialogAi', false);
		},
		async submitForm() {
			if (!this.form.username.value || !this.form.apartment.value || !this.form.email.value) {
				alert('필수 항목을 모두 입력해주세요.');
				return;
			}
			if (!this.check) {
				alert('개인정보 수집 및 이용에 동의해주세요.');
				return;
			}

			try {
				const content = this.createContentMessage();
				this.sendSlackMessage(content);

				this.ch_in_dialog = true;
				this.$store.commit('common/setDialogAi', false);
			} catch (error) {
				console.error('Slack 전송 실패:', error);
				alert('신청서 제출에 실패했습니다. 잠시 후 다시 시도해주세요.');
			}
		},
		createContentMessage() {
			// 1. 메시지 제목을 번역하여 가져옵니다.
			const title = this.$t('Banner_AI.DialogTitle');

			const contentArr = [title];
			const fieldOrder = ['username', 'apartment', 'phone', 'email'];

			for (const key of fieldOrder) {
				const value = this.form[key].value || '-';
				const label = this.$t(`IdeaPage.form.${key}`);
				contentArr.push(`${label}: ${value}`);
			}

			return contentArr.join('\n');
		},
		resetFormValues() {
			Object.keys(this.form).forEach(key => {
				const typedKey = key;
				this.form[typedKey].value = null;
			});
			this.check = ['white'];
		},
		sendSlackMessage(content) {
			this.$aws.lambda.invoke(
				process.env.VUE_APP_AWS_LAMBDA_CREATE_MESSAGE_SLACK,
				'RequestResponse',
				JSON.stringify({
					action: 'OFFICIAL',
					content: content
				})
		).then( res => {
				this.resetFormValues();
				this.dialog = true;
			});
		}
	},
};
</script>

<style scoped lang="scss">
.btn:hover {
	color: white !important;
	border-color: white !important;
	background-color: transparent !important;
}
</style>